<section class="relative flex flex-col items-center w-full min-w-0 overflow-x-hidden">
  <div class="relative flex flex-col w-full max-w-5xl gap-6 px-2 sm:px-3">
    <header class="min-w-0">
      <h1 class="text-xl sm:text-2xl font-semibold text-gray-900">Notifications</h1>
      <p class="text-sm text-gray-500 mt-1">Alertes et mises a jour de votre entreprise.</p>
    </header>

    <article class="rounded-xl border border-gray-200 bg-white shadow-sm min-w-0 overflow-hidden">
      @if (loading()) {
        <p class="p-5 text-sm text-gray-500">Chargement...</p>
      } @else if (!notifications().length) {
        <div class="p-5 text-sm text-gray-500 flex items-center gap-2">
          <span class="material-symbols-outlined">notifications_off</span>
          Aucune notification pour le moment.
        </div>
      } @else {
        <ul class="divide-y divide-gray-100">
          @for (notification of notifications(); track notification.id) {
            <li class="p-4 flex flex-col sm:flex-row sm:items-start sm:justify-between gap-3">
              <div class="min-w-0">
                <p class="font-medium text-gray-900 break-words">{{ notification.title }}</p>
                <p class="text-sm text-gray-600 mt-1 break-words">{{ notification.description }}</p>
                <p class="text-xs text-gray-500 mt-2">{{ notification.createdAt | date: 'dd/MM/yyyy HH:mm' }}</p>
              </div>
              @if (!notification.read) {
                <button
                  class="w-full sm:w-auto shrink-0 rounded-md border border-secondary/25 bg-secondary/10 px-3 py-2 sm:py-1.5 text-xs font-medium text-secondary hover:bg-secondary/15 cursor-pointer"
                  (click)="markAsRead(notification)"
                >
                  Marquer lu
                </button>
              }
            </li>
          }
        </ul>
      }
    </article>
  </div>
</section>
